<template>
  <div id="support">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li>
          <a href="#/technical-support">Technical Resources</a>
        </li>
        <li class="active">
          <a>Manage Technical Resources</a>
        </li>
      </ol>
    </div>

    <div class="content login" v-loading="loading">
      <div class="cell">
        <div class="container pb100">
          <div class="row mt20">
            <p class="sub-title text-center">Manage Technical Resources</p>

            <div class="col-xs-12 mb20">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingOne">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add new category"
                        placement="top"
                      >
                        <a href="#" data-toggle="modal" data-target="#category">
                          <span
                            class="iconfont2 icon-g7 button-icon mr20"
                          ></span>
                        </a> </el-tooltip
                      >CATEGORIES
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseOne"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-right w30"></th>
                        </tr>
                        <tbody>
                          <tr v-for="(i, index) in categories" :key="index">
                            <td class="w60">{{ i.name }}</td>
                            <td class="text-right w20">
                              <input class="border w10 mr20" :value="i.index = index" type="number" @change="sortCategories(i.index, parseInt($event.target.value))"/>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  data-toggle="modal"
                                  data-target="#category"
                                  @click="
                                    category = Object.assign({}, i);
                                    isCategoryEdit = true;
                                  "
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_category(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwo">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseTwo"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add technical documentation list"
                        placement="top"
                      >
                        <a href="#" data-toggle="modal" data-target="#tech">
                          <span
                            class="iconfont2 icon-g7 button-icon mr20"
                          ></span>
                        </a> </el-tooltip
                      >TECHNICAL DOCUMENTATION
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseTwo"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">List Name</th>
                          <th class="w15">Category</th>
                          <th class="text-center w30"></th>
                        </tr>
                        <tbody>
                          <tr
                            v-for="(i, index) in tech_documentation"
                            :key="index"
                          >
                            <td class>{{ i.name }}</td>
                            <td class>
                              {{ get_category_name(i.category_id) }}
                            </td>
                            <td class="text-right w30">
                              <a @click="open_tech(i)" class="black mr20"
                                >Open</a
                              >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  data-toggle="modal"
                                  data-target="#tech"
                                  @click="
                                    tech = Object.assign({}, i);
                                    isTechEdit = true;
                                  "
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_tech(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingThree">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseThree"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add new video"
                        placement="top"
                      >
                        <a href="#" data-toggle="modal" data-target="#video">
                          <span
                            class="iconfont2 icon-g7 button-icon mr20"
                          ></span>
                        </a> </el-tooltip
                      >TUTORIALS AND VIDEOS
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseThree"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="w15">Category</th>
                          <th>URL</th>
                          <th class="text-right w30"></th>
                        </tr>
                        <tbody>
                          <tr v-for="(i, index) in videos" :key="index">
                            <td class>{{ i.name }}</td>
                            <td class>
                              {{ get_category_name(i.category_id) }}
                            </td>
                            <td class>{{ i.url }}</td>
                            <td class="text-right w30">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  data-toggle="modal"
                                  data-target="#video"
                                  @click="
                                    video = Object.assign({}, i);
                                    isVideoEdit = true;
                                  "
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_video(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modals -->
    <!-- CATEGORY MODAL -->
    <div
      class="modal"
      id="category"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            @click="category_close"
            aria-label="Close"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">CATEGORY FORM</p>
            <div class="row">
              <div class="col-sm-10 col-sm-offset-1">
                <el-form
                  :model="category"
                  ref="category"
                  status-icon
                  validate-on-rule-change
                >
                  <table class="table mt30 font12">
                    <tr>
                      <td>Name</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="name"
                          :rules="[
                            { required: true, message: 'Name is required!' },
                          ]"
                        >
                          <el-input
                            v-model="category.name"
                            size="big"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-middle">Thumbnail image</td>
                      <td class="text-right">
                        <el-form-item
                          class="white"
                          prop="file_name"
                          :rules="[
                            {
                              required: !isCategoryEdit,
                              message: 'Image is required!',
                            },
                          ]"
                        >
                          <div class="center">
                            <img
                              style="width: 100%"
                              id="preview"
                              ref="preview"
                              :src="category_thumbnail_url"
                              alt="your image"
                            />
                          </div>
                          <el-input
                            type="file"
                            id="category_file"
                            v-model="category.file_name"
                            @input="handle_file_upload"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                  </table>
                </el-form>
                <div class="mt50 text-center">
                  <button
                    type="button"
                    @click="category_close()"
                    class="el-button mr20"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="el-button el-button--primary"
                    @click="category_submit()"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TECH MODAL -->
    <div
      class="modal"
      id="tech"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">TECHNICAL DOCUMENTATION FORM</p>
            <div class="row">
              <div class="col-sm-10 col-sm-offset-1">
                <el-form
                  :model="tech"
                  ref="tech"
                  status-icon
                  validate-on-rule-change
                >
                  <table class="table mt30 font12">
                    <tr>
                      <td>Name</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="name"
                          :rules="[
                            { required: true, message: 'Name is required!' },
                          ]"
                        >
                          <el-input v-model="tech.name" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>Category</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="category_id"
                          :rules="[
                            {
                              required: true,
                              message: 'Category is required!',
                            },
                          ]"
                        >
                          <el-select v-model="tech.category_id" size="big">
                            <el-option
                              v-for="(i, index) in categories"
                              :key="index"
                              :value="i._id"
                              :label="i.name"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                  </table>
                </el-form>
                <div class="mt50 text-center">
                  <button
                    type="button"
                    @click="tech_close()"
                    class="el-button mr20"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="el-button el-button--primary"
                    @click="tech_submit()"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIDEO MODAL -->
    <div
      class="modal"
      id="video"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            @click="video_close"
            aria-label="Close"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">VIDEO FORM</p>
            <div class="row">
              <div class="col-sm-10 col-sm-offset-1">
                <el-form
                  :model="video"
                  ref="video"
                  status-icon
                  validate-on-rule-change
                >
                  <table class="table mt30 font12">
                    <tr>
                      <td>Name</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="name"
                          :rules="[
                            { required: true, message: 'Name is required!' },
                          ]"
                        >
                          <el-input v-model="video.name" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-middle">Thumbnail image</td>
                      <td class="text-right">
                        <el-form-item
                          class="white"
                          prop="file_name"
                          :rules="[
                            {
                              required: !isVideoEdit,
                              message: 'Image is required!',
                            },
                          ]"
                        >
                          <div class="center">
                            <img
                              style="width: 100%"
                              id="video_preview"
                              ref="video_preview"
                              :src="video_thumbnail_url"
                              alt="your image"
                            />
                          </div>
                          <el-input
                            type="file"
                            id="video_file"
                            v-model="video.file_name"
                            @input="handle_video_file_upload"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-middle">URL</td>
                      <td class="text-right">
                        <el-form-item
                          class="white"
                          prop="url"
                          :rules="[
                            { required: true, message: 'URL is required!' },
                          ]"
                        >
                          <el-input v-model="video.url" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>Category</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="category_id"
                          :rules="[
                            {
                              required: true,
                              message: 'Category is required!',
                            },
                          ]"
                        >
                          <el-select v-model="video.category_id" size="big">
                            <el-option
                              v-for="(i, index) in categories"
                              :key="index"
                              :value="i._id"
                              :label="i.name"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                  </table>
                </el-form>
                <div class="mt50 text-center">
                  <button
                    type="button"
                    @click="video_close()"
                    class="el-button mr20"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="el-button el-button--primary"
                    @click="video_submit()"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.panel-title {
  height: 60px;
}
.modal-content {
  padding: 28px;
}
</style>
<script>
import axios from "axios";
export default {
  name: "technical-resources-manage",
  data() {
    return {
      category: {},
      categories: [],
      video: {},
      videos: [],
      tech: {},
      tech_documentation: [],
      loading: true,
      category_file: "",
      category_thumbnail_url: "",
      video_image_file: "",
      video_thumbnail_url: "",
      isCategoryEdit: false,
      isTechEdit: false,
      isVideoEdit: false,
    };
  },
  watch: {
    isCategoryEdit(newVal) {
      if (newVal) {
        this.category_thumbnail_url =
          this.$store.state.serverURL +
          "/" +
          this.category.file_name +
          "?" +
          Date.now();
        this.category.file_name = "";
      } else {
        this.category_thumbnail_url = "";
      }
    },
    isVideoEdit(newVal) {
      if (newVal) {
        this.video_thumbnail_url =
          this.$store.state.serverURL +
          "/" +
          this.video.file_name +
          "?" +
          Date.now();
        this.video.file_name = "";
      } else {
        this.video_thumbnail_url = "";
      }
    },
  },
  methods: {
    sortCategories(oldVal, newVal) {
      var maxIndex = this.categories.length - 1;
      
      if (newVal > maxIndex) {
        alert('Value is to big');
        return;
      } else if (newVal < 0) {
        alert('Value is to low');
        return;
      }

      var item1 = this.categories[newVal];
      item1.index = oldVal;
      var item2 = this.categories[oldVal];
      item2.index = newVal

      this.$set(this.categories, oldVal, item1);
      this.$set(this.categories, newVal, item2);
      this.updateCategories()
    },
    updateCategories() {
      axios
        .put("/support/tech/categories/sort", this.categories)
        .then(async (res) => {
          if (res.data == 'Done') {
            this.$message({
              type: "success",
              message: "Updated!",
            });
          } else {
            this.$message({
              type: "error",
              message: "Update Failed!",
            });
          }
        })
        .catch((error) => {
          alert(error);
      });
    },
    get_category_name(c_id) {
      var category = this.categories.find((c) => c._id == c_id);
      return category ? category.name : "";
    },
    handle_file_upload() {
      this.category_file = document.getElementById("category_file").files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.preview.setAttribute("src", e.target.result);
      };
      reader.readAsDataURL(this.category_file); // convert to base64 string
    },
    async get_categories() {
      return await axios.get("/support/tech/categories");
    },
    category_close() {
      window.$("#category").modal("hide");
      this.$refs.category.resetFields();
      this.$refs.preview.setAttribute("src", "");
      this.isCategoryEdit = false;
      this.category = {};
      this.loading = false;
    },
    add_category(formData) {
      axios
        .post("/support/tech/categories/add/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.category_close();
            var c = await this.get_categories();
            this.categories = c.data;
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
            this.category_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.category_close();
        });
    },
    edit_category(formData) {
      axios
        .put("/support/tech/categories/edit/" + this.category._id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Updated!",
            });
            this.category_close();
            var c = await this.get_categories();
            this.categories = c.data;
          } else {
            this.$message({
              type: "error",
              message: "Update Failed!",
            });
            this.category_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.category_close();
        });
    },
    delete_category(id, name) {
      axios;
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE CATEGORY",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/support/tech/categories/delete/" + id)
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  done();
                  var c = await this.get_categories();
                  this.categories = c.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
    category_submit() {
      this.$refs.category.validate((valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          if (this.category_file instanceof File) {
            formData.append("file", this.category_file);
          }
          for (var attr in this.category) {
            formData.append(attr, this.category[attr]);
          }
          if (this.isCategoryEdit) {
            this.edit_category(formData);
          } else {
            this.add_category(formData);
          }
        }
      });
    },
    async get_tech_documentation() {
      return await axios.get("/support/tech");
    },
    delete_tech(id, name) {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE TECHNICAL DOCUMENTATION LIST",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + " and all the files?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/support/tech/delete/" + id)
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  done();
                  var t = await this.get_tech_documentation();
                  this.tech_documentation = t.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
    tech_submit() {
      this.$refs.tech.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.isTechEdit) {
            axios
              .put("/support/tech/edit/" + this.tech._id, {
                tech: {
                  name: this.tech.name,
                  category_id: this.tech.category_id,
                },
              })
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Updated!",
                  });
                  this.tech_close();
                  var t = await this.get_tech_documentation();
                  this.tech_documentation = t.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Update Failed!",
                  });
                  this.tech_close();
                }
              })
              .catch((error) => {
                alert(error);
                this.tech_close();
              });
          } else {
            axios
              .post("/support/tech/add/", {
                tech: {
                  name: this.tech.name,
                  category_id: this.tech.category_id,
                },
              })
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Created!",
                  });
                  this.tech_close();
                  var t = await this.get_tech_documentation();
                  this.tech_documentation = t.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Create Failed!",
                  });
                  this.tech_close();
                }
              })
              .catch((error) => {
                alert(error);
                this.tech_close();
              });
          }
        }
      });
    },
    tech_close() {
      window.$("#tech").modal("hide");
      this.$refs.tech.resetFields();
      this.isTechEdit = false;
      this.tech = {};
      this.loading = false;
    },
    open_tech(tech) {
      this.$router.push({
        name: "technical-resources-manage-tech",
        params: { editTech: tech },
      });
    },
    handle_video_file_upload() {
      this.video_file = document.getElementById("video_file").files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.video_preview.setAttribute("src", e.target.result);
      };
      reader.readAsDataURL(this.video_file); // convert to base64 string
    },
    async get_videos() {
      return await axios.get("/support/tech/videos");
    },
    video_close() {
      window.$("#video").modal("hide");
      this.$refs.video.resetFields();
      this.$refs.video_preview.setAttribute("src", "");
      this.isVideoEdit = false;
      this.video = {};
      this.loading = false;
    },
    add_video(formData) {
      axios
        .post("/support/tech/videos/add/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.video_close();
            var v = await this.get_videos();
            this.videos = v.data;
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
            this.video_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.video_close();
        });
    },
    edit_video(formData) {
      axios
        .put("/support/tech/videos/edit/" + this.video._id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Updated!",
            });
            this.video_close();
            var v = await this.get_videos();
            this.videos = v.data;
          } else {
            this.$message({
              type: "error",
              message: "Update Failed!",
            });
            this.video_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.video_close();
        });
    },
    video_submit() {
      this.$refs.video.validate((valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          if (this.video_file instanceof File) {
            formData.append("file", this.video_file);
          }
          for (var attr in this.video) {
            formData.append(attr, this.video[attr]);
          }
          if (this.isVideoEdit) {
            this.edit_video(formData);
          } else {
            this.add_video(formData);
          }
        }
      });
    },
    delete_video(id, name) {
      axios;
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE VIDEO",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/support/tech/videos/delete/" + id)
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  done();
                  var v = await this.get_videos();
                  this.videos = v.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
  },
  async mounted() {
    var r1 = this.get_categories();
    var r2 = this.get_tech_documentation();
    var r4 = this.get_videos();
    var categories = await r1;
    var tech = await r2;
    var videos = await r4;
    this.categories = categories.data;
    this.tech_documentation = tech.data;
    this.videos = videos.data;
    this.loading = false;
  },
};
</script>

<style>
</style>
